// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { Card } from '../../styled-components/dark/common';
import AdaptativeModal from '../AdaptativeModal';
import RoundedButton from '../RoundedButton/RoundedButton';

const StyledAdaptativeModal = styled(AdaptativeModal)`
  max-width: 30em;

  --AdaptativeModalCloseButton-right: 2px;
  --AdaptativeModalCloseButton-top: 2px;
`;

const Wrapper = styled.div`
  background-color: ${theme.RealityCheckModal.backgroundColor};
  border-radius: ${Card.borderRadius};
  padding: 1em;
  color: white;
  text-align: center;
`;

const Header = styled.div`
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.5em;
`;

const WarningMinutes = styled.div`
  margin-bottom: 0.25em;
`;

const Message = styled.div``;

const StyledRoundedButton = styled(RoundedButton)``;

type RealityCheckModalProps = {
  className?: string;
  show: boolean;
  onClose: () => void;
};

const RealityCheckModal = ({ className = '', show, onClose }: RealityCheckModalProps) => {
  return (
    <StyledAdaptativeModal
      className={className}
      identifier="reality-check-modal"
      show={show}
      onClose={onClose}
      forbidBackgroundScrolling
    >
      <Wrapper className={className}>
        <Header>Reality Check</Header>
        <WarningMinutes>{__('You have been active for %1$s minutes now.', 60)}</WarningMinutes>
        <Message>{__('!desc:RealityCheckMessage')}</Message>
        <br />
        <StyledRoundedButton
          label={__('Close')}
          backgroundColor={theme.RealityCheckModal.closeButtonBackgroundColor}
          onClick={onClose}
        />
      </Wrapper>
    </StyledAdaptativeModal>
  );
};

export default RealityCheckModal;
